import { defineMessages } from 'react-intl';

export default defineMessages({
  amount: {
    id: 'sentinel.components.detailsHeader.amount',
    defaultMessage: 'Amount',
  },
  amountAvailable: {
    id: 'sentinel.components.detailsHeader.amountAvailable',
    defaultMessage: 'Amount Available',
  },
  account: {
    id: 'sentinel.components.detailsHeader.account',
    defaultMessage: 'Account',
  },
  correspondent: {
    id: 'sentinel.components.detailsHeader.correspondent',
    defaultMessage: 'Correspondent',
  },
  state: {
    id: 'sentinel.components.detailsHeader.state',
    defaultMessage: 'State',
  },
  rejectTransfer: {
    id: 'sentinel.containers.details.rejectTransfer',
    defaultMessage: 'Reject',
  },
  reopenTransfer: {
    id: 'sentinel.containers.details.reopenTransfer',
    defaultMessage: 'Reopen',
  },
  suspendTransfer: {
    id: 'sentinel.containers.details.suspendTransfer',
    defaultMessage: 'Suspend',
  },
  returnTransfer: {
    id: 'sentinel.containers.details.returnTransfer',
    defaultMessage: 'Return',
  },
  cancelTransfer: {
    id: 'sentinel.containers.details.cancelTransfer',
    defaultMessage: 'Cancel',
  },
});



// WEBPACK FOOTER //
// ./src/components/DetailsHeader/messages.js